import { toast } from 'react-toastify';

const commonConfig = {
    closeOnClick: true,  
    pauseOnHover: true,   
    draggable: true,      
    pauseOnFocusLoss: false,
    style: {
      userSelect: 'text',     // Enable text selection
      WebkitUserSelect: 'text', // For Safari support
      MozUserSelect: 'text',    // For Firefox support
      msUserSelect: 'text',     // For IE/Edge support
      cursor: 'auto',          // Show text cursor
    }
  };
  

const isDarkTheme = () => document.documentElement.getAttribute('dark-theme') === 'dark';

export const showToast = {
  success: (message) => {
    const messages = message.split('\n').filter(msg => msg.trim());
    messages.forEach(msg => {
      toast.success(msg, {
        ...commonConfig,
        style: {
          background: isDarkTheme() ? '#1e1e1e' : 'var(--toastSecondary)',
          color: '#ffffff',
          borderRadius: '8px',
        },
        progressStyle: {
          background: isDarkTheme() ? 'var(--toastSecondary)' : '#ffffff',
        },
      //   icon: '✅',
      });
    });
  },
  
  error: (message) => {
    const messages = message.split('\n').filter(msg => msg.trim());
    messages.forEach(msg => {
      toast.error(msg, {
        ...commonConfig,
        style: {
          background: isDarkTheme() ? '#1e1e1e' : '#ff4444',
          color: '#ffffff',
          borderRadius: '8px',
        },
        progressStyle: {
          background: isDarkTheme() ? '#ff4444' : '#ffffff',
        },
      //   icon: '❌',
      });
    });
  },

  warning: (message) => {
    const messages = message.split('\n').filter(msg => msg.trim());
    messages.forEach(msg => {
      toast.warning(msg, {
        ...commonConfig,
        style: {
          background: isDarkTheme() ? '#1e1e1e' : 'var(--toastPrimary)',
          color: '#ffffff',
          borderRadius: '8px',
        },
        progressStyle: {
          background: isDarkTheme() ? 'var(--toastPrimary)' : '#ffffff',
        },
      //   icon: '⚠️',
      });
    });
  },

  info: (message) => {
    const messages = message.split('\n').filter(msg => msg.trim());
    messages.forEach(msg => {
      toast.info(msg, {
        ...commonConfig,
        style: {
          background: isDarkTheme() ? '#1e1e1e' : '#2196f3',
          color: '#ffffff',
          borderRadius: '8px',
        },
        progressStyle: {
          background: isDarkTheme() ? '#2196f3' : '#ffffff',
        },
      //   icon: 'ℹ️',
      });
    });
  }
}; 